// extracted by mini-css-extract-plugin
export default {"main":"RecoveryPasswordLink_main__ppBHV"};